import { useEffect, useRef, useState } from 'react';
import NotificationOverlayFrame, { APP_CREAM } from './NotificationOverlayFrame';

const EVENT_NAME = 'jobflow:saved';

const SavedToastOverlay = ({ accentColor = '#E8761D' }) => {
  const [open, setOpen] = useState(false);
  const [message, setMessage] = useState('');
  const timerRef = useRef(null);
  const displayAccent = accentColor === '#E8761D' ? '#FFC107' : accentColor;

  useEffect(() => {
    const onSaved = (event) => {
      const suppliedMessage = typeof event.detail === 'string'
        ? event.detail
        : event.detail?.message;

      setMessage(String(suppliedMessage || 'Your changes were saved successfully.'));
      setOpen(true);
      if (timerRef.current) window.clearTimeout(timerRef.current);
      timerRef.current = window.setTimeout(() => setOpen(false), 2500);
    };

    window.addEventListener(EVENT_NAME, onSaved);
    return () => {
      window.removeEventListener(EVENT_NAME, onSaved);
      if (timerRef.current) window.clearTimeout(timerRef.current);
    };
  }, []);

  if (!open) return null;

  return (
    <NotificationOverlayFrame
      accentColor={displayAccent}
      messageColor={APP_CREAM}
      showLogo
      role="status"
      ariaLive="polite"
      ariaAtomic="true"
    >
      <div style={{
        fontWeight: 800,
        fontSize: 'clamp(18px, 2.2vw, 24px)',
        lineHeight: 1.35,
        overflowWrap: 'anywhere'
      }}>
        {message}
      </div>
    </NotificationOverlayFrame>
  );
};

export default SavedToastOverlay;
